export default __webpack_public_path__ + "static/media/gallery-wip-ammo-port-enclosure-body_01.c46ee937.jpg";